export default function PageFooter () {
    const currentYear = new Date().getFullYear();
    return (
        <footer className="atolFooter border-top">
            <div className="container-fluid">
                &copy; {currentYear} - Database Publishing Systems, Inc. - Powered by the <a href="http://dpsadtracker.com">DPS AdTracker&trade;</a> Platform &mdash; <a id="footCookie" href="#" target="_blank">Cookie Policy</a>&emsp;<a href="https://dpsadtracker.com/dps-generative-ai-usage-policy/" target="_blank">Generative AI Policy</a>&emsp;<a id="footPrivacy" href="#" target="_blank">Privacy Policy</a> <span id="serverName"></span>
            </div>
        </footer>
    );  
  }